<!-- Logs aggs component -->
<template>
  <!-- Aggs dropdown -->
  <div class="dropdown" :class="field">
    <!-- Button -->
    <button
      :disabled="disabled"
      class="btn dropdown-toggle"
      :class="noborder ? 'border-0 ' + field : 'btn-sm btn-outline-secondary'"
      type="button"
      :id="'dropdownMenuButton-' + field"
      data-bs-toggle="dropdown"
      aria-expanded="false"
    >
      <span v-if="showSpinner" class="spinner-border" role="status"></span>
      <span v-else>
        <span class="label" :class="field">{{ fieldLabel || field }}: </span>
        <span class="value">{{ current }}</span>
      </span>
    </button>

    <!-- Aggs list -->
    <ul class="dropdown-menu" :aria-labelledby="'dropdownMenuButton-' + field">
      <li v-for="(agg, index) in aggs" :key="index">
        <!-- Key element -->
        <div @click="newCurrent(agg.key.value)" class="pointer dropdown-item">
          {{ agg.key.value }}

          <!-- Copy to clipboard -->
          <span
            v-if="field == 'mapid' || field == 'userid'"
            @click.stop="copyToClipboard(agg.key.value)"
            class="bi bi-clipboard pointer"
            :class="agg.key.value == 'All ' + field + 's' ? 'hide' : ''"
          >
          </span>
        </div>

        <!-- Aggs user info -->
        <div v-if="agg.user">
          <div class="timestamp dropdown-item-text">
            name:
            <span
              class="text-muted pointer"
              @click.stop="copyToClipboard(agg.user.username)"
              >{{ agg.user.username }}</span
            >
          </div>

          <div class="timestamp dropdown-item-text">
            email:
            <span
              class="text-muted pointer"
              @click.stop="copyToClipboard(agg.user.email)"
              >{{ agg.user.email }}</span
            >
          </div>

          <div class="timestamp dropdown-item-text">
            sub:
            <span
              class="text-muted pointer"
              @click.stop="copyToClipboard(agg.user.sub)"
              >{{ agg.user.sub }}</span
            >
          </div>
        </div>

        <!-- Aggs additional elements -->
        <div v-for="(element, index) in elements" :key="index">
          <div
            v-if="
              agg[element.doc] &&
              agg[element.doc].hits.hits[0]._source[element.field]
            "
            class="timestamp dropdown-item-text"
          >
            {{ element.name }}:
            <span
              class="text-muted pointer"
              @click.stop="
                copyToClipboard(
                  agg[element.doc].hits.hits[0]._source[element.field]
                )
              "
            >
              {{
                (element.field == "@timestamp"
                  ? agg[element.doc].hits.hits[0]._source[element.field]
                      .replace("T", " ")
                      .replace("Z", "")
                  : agg[element.doc].hits.hits[0]._source[element.field]) + " "
              }}
            </span>
          </div>
        </div>

        <!-- Horizontal separator -->
        <div
          v-if="field == 'mapid' || field == 'userid'"
          class="dropdown-divider"
        ></div>
      </li>
    </ul>

    <!-- Toast -->
    <div
      v-if="field == 'mapid'"
      class="toast mt-3"
      role="alert"
      aria-live="assertive"
      aria-atomic="true"
      data-bs-autohide="false"
    >
      <div class="toast-header">
        <!-- <img src="..." class="rounded me-2" alt="..." /> -->
        <strong class="me-auto">Bootstrap</strong>
        <small>11 mins ago</small>
        <button
          type="button"
          class="btn-close"
          data-bs-dismiss="toast"
          aria-label="Close"
        ></button>
      </div>
      <div class="toast-body">Hello, world! This is a toast message.</div>
    </div>
  </div>
</template>

<script>
export default {
  name: "LogsAggs",

  props: {
    fieldLabel: String,
    selectaggs: String,
    disabled: Boolean,
    noborder: Boolean,
    refresh: Boolean,
    filter: String,
    field: String,
    all: String,
  },

  data: function () {
    return {
      aggs: [],
      current: "",
      loading: false,
      showSpinner: false,

      allAggsLabel: "",
      cmdAggsList: "",

      // Additional aggs elements
      elements: [
        {
          field: "game",
          name: "game",
          doc: "latest_doc",
        },
        {
          field: "level",
          name: "level",
          doc: "latest_doc",
        },
        {
          field: "region",
          name: "region",
          doc: "latest_doc",
        },
        {
          field: "@timestamp",
          name: "first",
          doc: "first_doc",
        },
        {
          field: "@timestamp",
          name: "latest",
          doc: "latest_doc",
        },
      ],
    };
  },

  emmits: ["selected"],

  mounted() {
    const that = this;

    // Make all aggs label and command
    this.allAggsLabel = this.field + "s";
    this.cmdAggsList = "logs.aggs/" + this.field;

    // Set current value
    this.setCurrent(this.selectaggs);

    // Add 'reader' which will receive data from WebRTC Data Channel
    this.reader = this.teoweb.addReader(function (gw, data) {
      that.loading = false;
      that.showSpinner = false;

      // Process error
      if (gw.err) {
        that.error = "Error: " + gw.err;
        return;
      }
      that.error = "";

      switch (gw.command) {
        // Process answer to cmdAggsList command
        case that.cmdAggsList: {
          that.webasmReady.then(() => {
            // Parse data and add to aggs
            const keys = JSON.parse(window.decompressData(data));
            if (!keys) return;
            that.aggs = [{ key: { value: "All " + that.allAggsLabel } }].concat(
              keys
            );

            // Remove empty keys from aggs
            that.aggs = that.aggs.filter((agg) => agg.key.value != "");
          });
          break;
        }
      }
    });

    // Send getAggsList command if filter property is undefined. If filter
    // property is defined then the getAggsList command will be send when filter
    // property changed in watcher filter method.
    if (this.filter == undefined) {
      this.whenLogin.then(that.getAggsList);
    }
  },

  methods: {
    /**
     * Copy text to clipboard.
     * @param {string} text - text to copy to clipboard
     */
    copyToClipboard(text) {
      // Copy text to clipboard
      navigator.clipboard.writeText(text);
    },

    /**
     * Get aggs list from server.
     * Send getAggsList command to server. Command contains filter property.
     * If filter property is undefined then send empty string as filter.
     * If filter property is defined then send it as filter.
     * Set loading to true and showSpinner to false.
     * After 250 ms if loading is true then set showSpinner to true.
     */
    getAggsList() {
      this.loading = true;
      this.teoweb.sendCmd(this.cmdAggsList, this.filter);
      setTimeout(() => {
        if (this.loading) this.showSpinner = true;
      }, 250);
    },

    /**
     * Handle select of new value from dropdown list.
     * Set current depending on selected value.
     * If selected value is "All " + allAggsLabel or empty string, then set
     * current to allAggsLabel.
     * If selected value is not "All " + allAggsLabel, then set current to
     * selected value.
     * If current is allAggsLabel and all property set than set current to all.
     * Emit selected event (send to parent).
     * @param {string} current - selected value
     */
    newCurrent(current) {
      // Set current depending on selected value
      if (current == "All " + this.allAggsLabel || current == "") {
        this.current = this.allAggsLabel;
      } else {
        this.current = current;
      }

      // Emit selected event (send to parent)
      this.$emit("selected", this.current);

      // If current is allAggsLabel and all property set than set current to all
      if (this.current == this.allAggsLabel && this.all) {
        this.current = this.all;
      }
    },

    /**
     * Set current value
     * @param {string} newValue - new value, if undefined or empty string, then
     *  set allAggsLabel or all property to current
     */
    setCurrent(newValue) {
      // Set current to newValue if newValue set
      if (newValue) {
        this.current = newValue;
        return;
      }

      // If all property set than set current to all
      if (this.all) {
        this.current = this.all;
        return;
      }

      // Set current to allAggsLabel
      this.current = this.allAggsLabel;
    },
  },

  watch: {
    /**
     * Watcher for selectaggs property. Set current to newValue if newValue set.
     * If newValue is undefined or empty string, then set allAggsLabel or all
     * property to current.
     * @param {string} newValue - new value
     */
    selectaggs: function (newValue) {
      this.setCurrent(newValue);
    },

    /**
     * Watcher for filter property. Get aggs list.
     */
    filter: function () {
      this.getAggsList();
    },

    /**
     * Watcher for refresh property. Get aggs list if refresh is true.
     * @param {boolean} newValue - new value
     */
    refresh: function (newValue) {
      if (!newValue) return;
      // Get aggs list
      this.getAggsList();
    },
  },
};
</script>

<style scoped>
button.border-0 {
  padding-left: 3px;
}

button.border-0 span.value {
  opacity: 0.8;
}
button.border-0 span.value:hover {
  opacity: 1 !important;
}

div.timestamp {
  font-size: small;
}

.pointer {
  cursor: pointer;
}
.pointer:hover {
  color: var(--ion-color-primary) !important;
}

.spinner-grow,
.spinner-border {
  width: 15px;
  height: 15px;
}

.mapid .dropdown-menu,
.userid .dropdown-menu {
  position: relative !important;
  transform: none !important;
}

.mapid .dropdown-menu.card:not(.show) {
  display: none !important;
}

span.label:not(.mapid):not(.userid) {
  display: none;
}
span.label.mapid {
  cursor: pointer;
}

.bi-clipboard.pointer {
  opacity: 0.4;
}
.bi-clipboard.pointer:hover {
  opacity: 1;
}

.hide {
  display: none;
}
</style>
